/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const AuthorLine = styled.div(
  () => css`
    width: 100%;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    border-top: 1px solid #888888;
    border-bottom: 1px solid#888888;
    padding: 4px 0;
  `
)
